@switch (state) {
  @case ('loading') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc">
        <span class="state-spinner" aria-hidden="true"></span>
        <p class="state-text">Carregando cotação…</p>
      </div>
    </div>
  }

  @case ('invalid') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc">
        <div class="state-icon-wrap state-icon-wrap--muted">
          <span class="material-symbols-outlined state-icon">link_off</span>
        </div>
        <h2>Link inválido ou expirado</h2>
        <p>Verifique se você abriu o link mais recente enviado por e-mail. Se o problema persistir, contate a empresa compradora.</p>
      </div>
    </div>
  }

  @case ('respondida') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc" [style.--cor-marca]="corMarca">
        <div class="state-icon-wrap state-icon-wrap--brand">
          <span class="material-symbols-outlined state-icon" [style.color]="corMarca">task_alt</span>
        </div>
        <h2>Cotação já respondida</h2>
        <p>Sua proposta para a cotação <strong>{{ (detalhe ?? resumo)?.numeroCotacao }}</strong> já foi registrada. Obrigado!</p>
      </div>
    </div>
  }

  @case ('encerrada') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc" [style.--cor-marca]="corMarca">
        <div class="state-icon-wrap state-icon-wrap--muted">
          <span class="material-symbols-outlined state-icon">lock_clock</span>
        </div>
        <h2>Cotação encerrada</h2>
        <p>A cotação <strong>{{ (detalhe ?? resumo)?.numeroCotacao }}</strong> já foi concluída pela empresa compradora e não aceita mais propostas. Se precisar, entre em contato com ela.</p>
      </div>
    </div>
  }

  @case ('sucesso') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc" [style.--cor-marca]="corMarca">
        <div class="state-icon-wrap state-icon-wrap--brand">
          <span class="material-symbols-outlined state-icon" [style.color]="corMarca">check_circle</span>
        </div>
        <h2>Proposta enviada!</h2>
        <p>Recebemos sua resposta para a cotação <strong>{{ detalhe?.numeroCotacao }}</strong>. A equipe de compras será notificada.</p>
      </div>
    </div>
  }

  @case ('gate') {
    <div class="portal-page portal-page--gate">
      <div class="portal-doc gate-doc" [style.--cor-marca]="corMarca">
        <header class="portal-hero" [style.background]="heroGradient">
          <div class="hero-brand">
            @if (resumo?.urlLogo) {
              <span class="hero-logo"><img [src]="resumo?.urlLogo" alt="Logo"></span>
            } @else {
              <span class="hero-logo-fallback" [style.background]="corMarca">{{ resumo?.marcaSigla || 'ATS' }}</span>
            }
            <div class="hero-brand-text">
              <strong>{{ resumo?.empresaNome }}</strong>
              <span>Portal do fornecedor</span>
            </div>
          </div>
        </header>

        <div class="gate-body">
          <div class="gate-icon-wrap">
            <span class="material-symbols-outlined gate-icon">lock</span>
          </div>
          <h2>Confirme sua identidade</h2>
          <p>Para abrir esta cotação, informe os <strong>5 primeiros dígitos do CNPJ/CPF</strong> da sua empresa.</p>

          <form class="gate-form" (ngSubmit)="abrir()">
            <div class="gate-form-row">
              <label class="gate-field">
                <span class="gate-field-label">Primeiros 5 dígitos</span>
                <input class="gate-input" [(ngModel)]="documento" name="documento"
                  inputmode="text" maxlength="5" autocomplete="off"
                  placeholder="A B 1 2 3" [disabled]="abrindo">
              </label>
              <button type="submit" class="btn-primary gate-submit" [style.background]="corMarca"
                [disabled]="abrindo || !podeAbrir">
                @if (abrindo) {
                  <span class="gate-spinner" aria-hidden="true"></span>
                  Abrindo…
                } @else {
                  <span class="material-symbols-outlined">lock_open</span>
                  Abrir cotação
                }
              </button>
            </div>
            @if (gateErro) { <p class="gate-erro">{{ gateErro }}</p> }
          </form>
        </div>
      </div>
    </div>
  }

  @case ('form') {
    <div class="portal-page">
      <div class="portal-doc">
        <header class="portal-hero" [style.background]="heroGradient">
          <div class="hero-brand">
            @if (detalhe?.urlLogo) {
              <span class="hero-logo"><img [src]="detalhe?.urlLogo" alt="Logo"></span>
            } @else {
              <span class="hero-logo-fallback" [style.background]="corMarca">{{ detalhe?.marcaSigla || 'ATS' }}</span>
            }
            <div class="hero-brand-text">
              <strong>{{ detalhe?.empresaNome }}</strong>
              <span>Preencha e envie sua proposta</span>
            </div>
          </div>
          <div class="hero-meta">
            <div class="hero-doc-type">Solicitação de cotação</div>
            <div class="hero-doc-number">{{ detalhe?.numeroCotacao }}</div>
            @if (detalhe?.dataEntregaDesejada) {
              <div class="hero-chips">
                <span class="hero-chip">
                  <span class="material-symbols-outlined">event</span>
                  Entrega desejada: {{ detalhe?.dataEntregaDesejada | date:'dd/MM/yyyy' }}
                </span>
              </div>
            }
          </div>
        </header>

        <div class="portal-body">
          <section class="portal-section">
            <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Itens</h3>
            <div class="items-list">
              @for (item of detalhe?.itens; track item.idCompraItem) {
                <article class="item-card" [class.item-off]="isIndisponivel(item)">
                  <div class="item-card-head">
                    <div class="item-nome">
                      <strong>{{ item.nome }}</strong>
                      @if (item.codigoSku) { <small>SKU {{ item.codigoSku }}</small> }
                    </div>
                    <span class="item-qtd">{{ item.quantidadeSolicitada }} {{ item.unidade }}</span>
                  </div>

                  <div class="item-fields">
                    @if (isAtivo('campoPrecoUnitario')) {
                      <label class="item-field">
                        <span>Preço unitário</span>
                        <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                          [(ngModel)]="item.valorUnitario" [disabled]="isIndisponivel(item)" placeholder="R$ 0,00">
                      </label>
                    }
                    @if (isAtivo('campoIpi')) {
                      <label class="item-field">
                        <span>IPI</span>
                        <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                          [(ngModel)]="item.valorIpi" [disabled]="isIndisponivel(item)" placeholder="R$ 0,00">
                      </label>
                    }
                    @if (isAtivo('campoSt')) {
                      <label class="item-field">
                        <span>ST</span>
                        <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                          [(ngModel)]="item.valorIcmsSt" [disabled]="isIndisponivel(item)" placeholder="R$ 0,00">
                      </label>
                    }
                    @if (item.marcaProduto) {
                      <label class="item-field">
                        <span>Marca</span>
                        <input class="cell-input" [value]="item.marcaProduto" disabled>
                      </label>
                    } @else {
                      <label class="item-field">
                        <span>Marca ofertada</span>
                        <input class="cell-input" [(ngModel)]="item.marcaOfertada" [disabled]="isIndisponivel(item)" placeholder="—">
                      </label>
                    }
                    @if (isAtivo('campoPrazoEntrega')) {
                      <label class="item-field">
                        <span>Prazo (dias)</span>
                        <input class="cell-input num" type="number" min="0"
                          [(ngModel)]="item.prazoEntregaDias" [disabled]="isIndisponivel(item)" placeholder="—">
                      </label>
                    }
                    @if (isAtivo('campoDisponibilidade')) {
                      <label class="item-field">
                        <span>Disponível (un.)</span>
                        <input class="cell-input num" type="number" min="0" step="1"
                          [(ngModel)]="item.quantidade" placeholder="0" title="Unidades disponíveis (0 = sem estoque)">
                      </label>
                    }
                  </div>

                  <div class="item-alt">
                    <button type="button" class="item-alt-toggle" (click)="toggleAlternativa(item)" [disabled]="isIndisponivel(item)">
                      {{ item.alternativaAberta ? '− Remover alternativa' : '+ Oferecer alternativa' }}
                    </button>
                    @if (item.alternativaAberta) {
                      <div class="item-fields item-alt-fields">
                        <label class="item-field item-field--wide">
                          <span>Descrição da alternativa</span>
                          <input class="cell-input" [(ngModel)]="item.alternativaDescricao" placeholder="Produto/observação alternativa">
                        </label>
                        @if (isAtivo('campoPrecoUnitario')) {
                          <label class="item-field">
                            <span>Preço unitário (alt.)</span>
                            <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                              [(ngModel)]="item.alternativaValorUnitario" placeholder="R$ 0,00">
                          </label>
                        }
                        @if (isAtivo('campoIpi')) {
                          <label class="item-field">
                            <span>IPI (alt.)</span>
                            <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                              [(ngModel)]="item.alternativaValorIpi" placeholder="R$ 0,00">
                          </label>
                        }
                        @if (isAtivo('campoSt')) {
                          <label class="item-field">
                            <span>ST (alt.)</span>
                            <input class="cell-input num" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                              [(ngModel)]="item.alternativaValorIcmsSt" placeholder="R$ 0,00">
                          </label>
                        }
                        <label class="item-field">
                          <span>Marca alternativa</span>
                          <input class="cell-input" [(ngModel)]="item.alternativaMarca" placeholder="—">
                        </label>
                        @if (isAtivo('campoPrazoEntrega')) {
                          <label class="item-field">
                            <span>Prazo (alt., dias)</span>
                            <input class="cell-input num" type="number" min="0"
                              [(ngModel)]="item.alternativaPrazoEntregaDias" placeholder="—">
                          </label>
                        }
                        @if (isAtivo('campoDisponibilidade')) {
                          <label class="item-field">
                            <span>Disponível (alt., un.)</span>
                            <input class="cell-input num" type="number" min="0" step="1"
                              [(ngModel)]="item.alternativaQuantidade" placeholder="0" title="Unidades disponíveis da alternativa">
                          </label>
                        }
                      </div>
                    }
                  </div>
                </article>
              }
            </div>
          </section>

          <section class="portal-section">
            <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Condições da proposta</h3>
            <div class="cond-grid">
              @if (isAtivo('campoCondicaoPagamento')) {
                <div class="cond-field cond-field--wide">
                  <span>Condição de pagamento</span>
                  <div class="cond-parc-expr">
                    <input class="cell-input" [(ngModel)]="condicaoPagamento"
                      placeholder="Ex.: 30 60 90, 3x ou 15 +2x" (keydown.enter)="gerarParcelas()">
                    <button type="button" class="cond-parc-btn" (click)="gerarParcelas()">gerar parcelas</button>
                  </div>
                  <small class="cond-parc-hint">Número de parcelas ou prazos. Ex.: <b>30 60</b>, <b>3x</b> ou <b>15 +2x</b></small>
                  @if (parcelas.length) {
                    <table class="cond-parc-table">
                      <thead>
                        <tr><th>Nº</th><th>Dias</th><th>Data</th><th>Meio de pagamento da NF-e</th><th></th></tr>
                      </thead>
                      <tbody>
                        @for (p of parcelas; track $index) {
                          <tr>
                            <td>{{ $index + 1 }}</td>
                            <td><input class="cell-input num" type="number" min="0" [(ngModel)]="p.dias"></td>
                            <td><input class="cell-input" type="date" [(ngModel)]="p.data"></td>
                            <td>
                              <select class="cell-input" [(ngModel)]="p.meio">
                                @for (m of meioOpcoes; track m) { <option [ngValue]="m">{{ m }}</option> }
                              </select>
                            </td>
                            <td><button type="button" class="cond-parc-del" (click)="removeParcela($index)" title="Remover">×</button></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  <button type="button" class="cond-parc-add" (click)="addParcela()">+ adicionar outra parcela</button>
                </div>
              }
              @if (isAtivo('campoFrete')) {
                <label class="cond-field">
                  <span>Modalidade de frete</span>
                  <select class="cell-input" [(ngModel)]="idTipoFrete">
                    <option [ngValue]="null">Selecione…</option>
                    @for (tipo of tiposFrete; track tipo.idTipoFrete) {
                      <option [ngValue]="tipo.idTipoFrete">{{ tipo.descricao }}</option>
                    }
                  </select>
                </label>
                <label class="cond-field">
                  <span>Valor do frete (R$)</span>
                  <input class="cell-input" type="text" inputmode="decimal" [currencyMask]="moedaMask" [(ngModel)]="valorFrete" placeholder="R$ 0,00">
                </label>
              }
              @if (isAtivo('campoValidadeProposta')) {
                <label class="cond-field">
                  <span>Validade da proposta (dias)</span>
                  <input class="cell-input" type="number" min="0" [(ngModel)]="validadeDias" placeholder="Ex.: 15">
                </label>
              }
              <label class="cond-field cond-field--wide">
                <span>Observações</span>
                <textarea class="cell-input" rows="3" [(ngModel)]="observacoes" placeholder="Informações adicionais"></textarea>
              </label>
            </div>
          </section>

          @if (gateErro) { <p class="gate-erro">{{ gateErro }}</p> }

          <section class="portal-section portal-submit">
            <button type="button" class="btn-primary" [style.background]="corMarca" [disabled]="salvando" (click)="enviar()">
              <span class="material-symbols-outlined">send</span>
              {{ salvando ? 'Enviando…' : 'Enviar proposta' }}
            </button>
          </section>
        </div>

        <footer class="portal-footer">
          {{ detalhe?.empresaNome }}
          @if (detalhe?.emailContato) { · {{ detalhe?.emailContato }} }
          @if (detalhe?.telefoneContato) { · {{ detalhe?.telefoneContato }} }
        </footer>
      </div>
    </div>
  }
}
